const state = {
  changelog: [
    {
      version: 1.3,
      title: 'New beta release',
      summary: 'Removed taxes from rate cards, switched weeks working to weeks off, plus other copy updates and bug fixes. Warning! These changes will affect your calculated rate card values',
      notes: 'https://www.notion.so/louderthanten/Beta-1-3-8f0ca0e500a6448380fa78de9a4370e0'
    }
  ]
}

const getters = {
  latestChange: state => {
    const lastChange = state.changelog.slice(-1)
    return lastChange[0]
  }
}

export default {
  state,
  getters
}
